import { Component, computed, inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AuthSelectors, UserState } from '@ngrx-store';
import { MessageComponent } from '@ui';

import { TotpAuthStore } from './totp-auth.store';
import { TotpEnrollDialogComponent } from './totp-enroll-dialog.component';

@Component({
  imports: [MessageComponent, MatButtonModule],
  selector: 'avs-totp-required-banner',
  templateUrl: './totp-required-banner.component.html',
})
export class TotpRequiredBannerComponent {
  protected daysRemaining = computed(() => {
    const gracePeriodEndsAt = this.user()?.totpGracePeriodEndsAt;

    return gracePeriodEndsAt
      ? Math.max(0, Math.ceil((new Date(gracePeriodEndsAt).getTime() - Date.now()) / (24 * 60 * 60 * 1000)))
      : 0;
  });

  protected isVisible = computed(
    () => !this.store.bannerDismissed() && !this.user()?.totpEnabled && !!this.user()?.totpGracePeriodEndsAt,
  );
  protected user: Signal<UserState | undefined>;

  private dialog = inject(MatDialog);
  private store = inject(TotpAuthStore);
  private ngrxStore = inject(Store);

  constructor() {
    this.user = toSignal(this.ngrxStore.select(AuthSelectors.selectUser));
  }

  protected dismiss() {
    this.store.dismissBanner();
  }

  protected enable() {
    this.dialog.open(TotpEnrollDialogComponent, {
      backdropClass: 'backdrop-modal-panel',
      disableClose: true,
    });
  }
}
